var _G, _Path, _Path2, _Path3, _Path4, _Path5, _Path6, _Path7, _Path8, _Path9, _Path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconTrophy = function SvgIconTrophy(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    fill: "#FFC229"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M7.236 12.207c-1.178 0-2.259-.303-3.21-.901-.801-.504-1.514-1.22-2.119-2.127C.847 7.588.306 5.701.039 4.398a1.87 1.87 0 0 1 .394-1.58 1.58 1.58 0 0 1 1.2-.564h2.828V3.56H1.633c-.062 0-.116.047-.15.087a.6.6 0 0 0-.11.498c.244 1.191.733 2.91 1.679 4.328 1.073 1.61 2.481 2.426 4.184 2.426zM14.763 12.207V10.9c1.704 0 3.112-.816 4.185-2.426.945-1.419 1.435-3.137 1.679-4.328a.6.6 0 0 0-.11-.498c-.034-.04-.088-.087-.15-.087h-2.828V2.254h2.828c.456 0 .893.205 1.2.564.363.423.51 1.014.394 1.58-.267 1.303-.807 3.19-1.868 4.781-.605.908-1.318 1.623-2.119 2.126-.951.599-2.032.902-3.21.902"
  }))), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF8B00",
    d: "M12.595 12.78h-3.19v3.467h3.19z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFC229",
    d: "M13.568 16.803v1.83H8.432v-1.83c0-.307.26-.557.58-.557h3.977c.32 0 .579.25.579.557"
  })), _Path3 || (_Path3 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FC2B36",
    d: "M16.066 18.498v1.183a.325.325 0 0 1-.331.32h-9.47a.325.325 0 0 1-.332-.32v-1.183c0-.68.575-1.232 1.282-1.232h7.57c.707 0 1.282.552 1.282 1.232"
  })), _Path4 || (_Path4 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFD652",
    d: "M19.206 1.194C19.09 4.668 18.133 14.523 11 14.523c-3.88 0-5.933-2.916-7.017-6.134C9.196 7.386 13.417 4.184 15.205 0h3.01c.562 0 1.012.542.99 1.194"
  })), _Path5 || (_Path5 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFE47C",
    d: "M15.205 0c-1.788 4.184-6.01 7.386-11.222 8.389-.909-2.699-1.136-5.61-1.189-7.195C2.772.542 3.223 0 3.784 0z"
  })), _Path6 || (_Path6 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FF8B00",
    d: "M11 11.173c2.574 0 4.661-2.006 4.661-4.48S13.574 2.212 11 2.212c-2.575 0-4.662 2.006-4.662 4.48S8.425 11.174 11 11.174"
  })), _Path7 || (_Path7 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFE47C",
    d: "M12.944 17.973H9.056v1.32h3.888z"
  })), _Path8 || (_Path8 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFD652",
    d: "m9.29 19.293 1.71-1.32h1.944v1.32zM12.88 6.95a.25.25 0 0 0-.062.182l.122 1.535c.015.187-.18.323-.36.252l-1.48-.586a.27.27 0 0 0-.2 0l-1.48.586c-.18.07-.375-.065-.36-.252l.122-1.535a.25.25 0 0 0-.062-.182l-.324-.367a11.3 11.3 0 0 0 2.979-2.136l.287.449a.26.26 0 0 0 .161.112l1.557.363c.189.044.264.264.137.406z"
  })), _Path9 || (_Path9 = /*#__PURE__*/React.createElement(Path, {
    fill: "#FFE47C",
    d: "M11.775 4.447a11.3 11.3 0 0 1-2.98 2.136l-.713-.806a.248.248 0 0 1 .138-.406l1.557-.363a.26.26 0 0 0 .16-.112l.84-1.311a.267.267 0 0 1 .445 0z"
  })), _Path0 || (_Path0 = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "m8.86 3.127.002-.004.002-.004.001-.005.002-.004.002-.005V3.1h.001l.001-.005v-.004l.002-.005v-.005l.001-.014a.135.135 0 0 0-.082-.129l-.324-.144a1.52 1.52 0 0 1-.754-.724l-.15-.312a.14.14 0 0 0-.129-.079.14.14 0 0 0-.13.08l-.15.311c-.153.32-.42.577-.753.724l-.324.145a.14.14 0 0 0-.082.12v.004c0 .05.027.1.082.124l.324.144c.333.148.6.405.754.724l.15.312c.044.092.17.104.234.035l.002-.002.002-.002a.1.1 0 0 0 .02-.03l.15-.313q.026-.052.054-.102c.159-.272.403-.49.7-.621l.146-.066.177-.079a.14.14 0 0 0 .065-.056l.002-.004z"
  })));
};
export default SvgIconTrophy;